<template>
  <header
    :class="[
      $style.container, {
        [$style.centeredText] : centered,
      }
    ]"
  >
    <Component
      :is="headerIcon"
      v-if="headerIcon"
      :class="{
        [$style.headerIcon]: useHeaderIconStyleClass,
        [$style.applicationLogoStyleClass]: !useHeaderIconStyleClass
      }"
    />
    <div
      :class="{
        [$style.headerContainer]: showBackArrow,
      }"
      data-test-id="headerContainer"
    >
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" v-if="showBackArrow" :class="[$style.backArrow, $style.headerClickable]" v-bind:svg-inline="''" @click="headerClicked" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8 16l1.41-1.41L3.83 9H16V7H3.83l5.58-5.59L8 0 0 8l8 8z" fill="#000"/></svg>
      <h1
        :class="{
          [$style.headerText] : true,
          [$style.centeredHeaderText] : centered,
          [$style.headerTextWithIcon] : headerIcon,
          [$style.headerClickable] : headerIsClickable,
          [$style.userImportHeader] : isUserImportModal,
        }"
        @click="headerClicked"
      >
        {{ headerText }}
      </h1>
      <p
        v-if="headerSubtext && subTextUnderTitle"
        :class="{
          [$style.modalSubtitle]: true,
          [$style.userImportSubHeader] : isUserImportModal,
        }"
      >
        {{ headerSubtext }}
      </p>
      <div
        v-if="this.$slots.subtitle"
        :class="$style.modalSubtitle"
      >
        <slot name="subtitle" />
      </div>
      <slot name="disclaimer" />
    </div>
    <button
      v-if="showClose"
      :class="$style.closeIconContainer"
      @click="handleClose"
    >
      <i class="jc-actions-add" />
    </button>
    <p
      v-if="headerSubtext && !subTextUnderTitle"
      :class="$style.modalHeaderSubtext"
    >
      {{ headerSubtext }}
    </p>
    <slot />
  </header>
</template>

<script>
export default {
  name: 'ModalHeader',

  props: {
    centered: {
      default: false,
      type: Boolean,
    },
    handleClose: {
      default: () => {},
      type: Function,
    },
    headerIcon: {
      default: undefined,
      type: Object,
    },
    headerIsClickable: {
      default: false,
      type: Boolean,
    },
    headerSubtext: {
      default: '',
      type: String,
    },
    headerText: {
      default: '',
      type: String,
    },
    isUserImportModal: {
      type: Boolean,
      default: false,
    },
    showBackArrow: {
      default: false,
      type: Boolean,
    },
    showClose: {
      default: true,
      type: Boolean,
    },
    subTextUnderTitle: {
      default: false,
      type: Boolean,
    },
    useHeaderIconStyleClass: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    headerClicked() {
      this.$emit('headerClicked');
    },
  },
};
</script>

<style scoped module>
@value (gradientDark1, gradientLight3, gradientDark1) from '~css/colors.css';

.applicationLogoStyleClass {
  margin-left: 4.21rem;
  max-width: 13rem;
}

.backArrow {
  height: 2rem;
  margin-bottom: 0.6rem;
  margin-left: 2rem;
  margin-top: 1rem;
}

.centeredHeaderText.headerText {
  padding-left: 70px;
  text-align: center;
}

.centeredText {
  text-align: center;
}

.container {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  padding-top: 0.8rem;
  position: relative;
  top: 0 !important;
}

.headerIcon {
  display: inline-block;
  font-size: 75px;
  height: 75px;
  margin-left: 4.21rem;
  vertical-align: top;
  width: 75px;
}

.headerClickable {
  cursor: pointer;
}

.headerContainer {
  display: flex;
}

.headerText {
  color: gradientDark1;
  display: inline-block;
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1;
  margin-top: 0;
  padding: 14px 70px 0 35px;
  text-align: left;
}

.headerTextWithIcon {
  line-height: 47px; /* headerIcon font-size - modalHeader top/bottom padding */
  vertical-align: middle;
}

.modalSubtitle {
  font-size: 1.25rem;
  padding: 0 70px 14px 35px;
}

.modalHeaderSubtext {
  margin: 0;
  padding: 0 35px 14px;
}

.closeIconContainer {
  background-color: transparent;
  border: 0 !important;
  border-radius: 50px;
  color: gradientDark1 !important;
  cursor: pointer;
  font-size: 44px;
  height: 44px;
  line-height: 44px;
  margin: 10px 16px !important;
  outline: none;
  padding: 0;
  position: absolute;
  right: 0;
  text-shadow: none;
  top: 0;
  transform: rotate(45deg);
  transition: background-color 0.13s ease-in-out;
  width: 44px;
}

.closeIconContainer:hover {
  background-color: gradientLight3;
  box-shadow: none;
  text-decoration: none;
}

.userImportHeader {
  font-size: 1.85rem;
  margin-bottom: -0.7rem;
}

.userImportSubHeader {
  font-size: 1.1rem;
  margin-bottom: 0;
}

</style>
